import { type HandledError, handleQueryError } from '@/shared/utils/helpers/handle-query-error';

import type { TCustomError } from '@/shared';

export const handleConfigCurrencyCreateError = (error?: HandledError): TCustomError | undefined => {
  const queryError = handleQueryError(error);

  if (!queryError) {
    return;
  }

  if (typeof queryError === 'string') {
    return { root: queryError };
  }

  const { detail } = queryError;
  if (typeof detail === 'string') {
    return {
      root: detail === 'Currency already exists'
        ? 'Валюта уже существует'
        : detail,
    };
  }

  if (Array.isArray(detail)) {
    return { root: detail.map((item) => item.msg).join('. ') };
  }

  return { root: 'Unknown error' };
};

export const handleConfigTelegramChatRoutingUpdateError = (
  error?: HandledError,
): TCustomError | undefined => {
  const queryError = handleQueryError(error);

  if (!queryError) {
    return;
  }

  if (typeof queryError === 'string') {
    return { root: queryError };
  }

  const { detail } = queryError;
  if (typeof detail === 'string') {
    return { root: detail };
  }

  if (Array.isArray(detail)) {
    return { root: detail.map((item) => item.msg).join('. ') };
  }

  return { root: 'Unknown error' };
};

export const handleConfigEmailUpdateError = (error?: HandledError): TCustomError | undefined => {
  const queryError = handleQueryError(error);

  if (queryError) {
    if (typeof queryError === 'string') {
      return {
        root: queryError
      };
    }

    const { detail } = queryError;

    if (typeof detail === 'string') {
      const errors: TCustomError = {};
      switch (detail) {
        case 'Some error':
          errors.message = 'Какая-то ошибка'
          break;
        default:
          errors.root = detail;
      }

      return errors;
    }

    if (Array.isArray(detail)) {
      const errors: TCustomError = {};
      detail.forEach((err) => {
        const location = err.loc?.[1];
        const message = err.msg;
        switch (location) {
          case 'some error':
            errors.message = message;
            break;
          default:
            errors.root = message;
        }
      });

      return errors;
    }

    return {
      root: 'Unknown error',
    };
  }
};

export const handleConfigSmsUpdateError = (error?: HandledError): TCustomError | undefined => {
  const queryError = handleQueryError(error);

  if (queryError) {
    if (typeof queryError === 'string') {
      return {
        root: queryError
      };
    }

    const { detail } = queryError;

    if (typeof detail === 'string') {
      const errors: TCustomError = {};
      switch (detail) {
        case 'Some error':
          errors.message = 'Какая-то ошибка'
          break;
        default:
          errors.root = detail;
      }

      return errors;
    }

    if (Array.isArray(detail)) {
      const errors: TCustomError = {};
      detail.forEach((err) => {
        const location = err.loc?.[1];
        const message = err.msg;
        switch (location) {
          case 'some error':
            errors.message = message;
            break;
          default:
            errors.root = message;
        }
      });

      return errors;
    }

    return {
      root: 'Unknown error',
    };
  }
};
